import React from "react";

const EmptyHint: React.FC<{
  icon?: string;
  title: string;
  subtitle?: string;
}> = ({ icon = "bi-info-circle", title, subtitle }) => (
  <div
    className="card"
    style={{ padding: 40, textAlign: "center", color: "var(--c-muted)" }}
  >
    <i className={`bi ${icon}`} style={{ fontSize: 28 }} />
    <div className="fw-600 mt-2" style={{ color: "var(--c-text)" }}>
      {title}
    </div>
    {subtitle && <div className="text-sm mt-2">{subtitle}</div>}
  </div>
);

export default EmptyHint;
